import { useNavigationState } from '@react-navigation/native';

export const useGetActiveTabRouteIndex = () => {
  const state = useNavigationState((x) => x.routes[0].state);
  const activeTabRoute = state?.routes[state?.index || 0];
  return activeTabRoute?.state?.index || 0;
};
